import { render, staticRenderFns } from "./CreateSalesOrder.vue?vue&type=template&id=68a31b4d&scoped=true&"
import script from "./CreateSalesOrder.vue?vue&type=script&lang=js&"
export * from "./CreateSalesOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateSalesOrder.vue?vue&type=style&index=0&id=68a31b4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a31b4d",
  null
  
)

export default component.exports